import Vue from 'vue';
import axios from 'axios';
import cookie from 'cookie-machine';
import moment from 'moment';
import JsonExcel from 'vue-json-excel';
import DatetimePicker from 'vuetify-datetime-picker';
import Loading from 'vue-loading-overlay';
import App from './App';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { debounce } from 'lodash';
import i18n from './i18n';

import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.min.css';
import './style.scss';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.config.productionTip = false;

Vue.use(Loading);

Vue.filter('dateTimeView', value => (value ? moment(new Date(value)).format('DD.MM.YYYY') : ''));
Vue.filter('dateWithTimeView', value => (value ? moment(new Date(value)).format('DD.MM.YYYY hh:mm') : ''));

Vue.use(DatetimePicker);

// region axios
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
// axios.defaults.withCredentials = true; // CORS için önemli
axios.interceptors.request.use((config) => {
  const token = cookie.get('token');
  if (token != null) {
    // eslint-disable-next-line
    config.headers.Authorization = `Bearer ${token}`;
  }

  // config.headers['Cache-Control'] = 'no-cache';
  // config.headers['Pragma'] = 'no-cache';

  return config;
}, err => Promise.reject(err));

const eventBus = new Vue();

const debouncedUpdateNotificationCount = debounce(async () => {
  try {
    const response = await axios.get('Summary/GetSummary', { skipInterceptor: true });
    store.summaryCalculated = true;
    eventBus.$emit('change-name', response.data);
  } catch (error) {
    console.error('Summary/GetSummary hatası:', error);
  } 
}, 2000); // 1 saniye debounce

axios.interceptors.response.use(async (response) => {
  const token = cookie.get('token');
  const summaryCalculated = store.summaryCalculated;

  if (token && (!summaryCalculated || response.config.url.includes('Approve') || response.config.url.includes('Reject'))) {
    debouncedUpdateNotificationCount();
  }
  return response;
}, (err) => {
  if (err.response && err.response.status === 401) {
    console.log('401 hatası, login sayfasına yönlendiriliyor');
    // store.dispatch('stopLoading'); // Hata durumunda loading'i durdur
    router.push('/login');
  }
  return Promise.reject(err);
});
// endregion

Vue.component('downloadExcel', JsonExcel);
Vue.prototype.$bus = eventBus;

Vue.filter('toCurrency', function (value) {
  let val = (value/1).toFixed(2).replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
});

const isMobile = ()=>{
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true
  } else {
    return false
  }
}

if(isMobile()){
  store.state.app.drawerVisible = false;
}

// Yeni bir dil seçme fonksiyonu (locale değişimi yapar)
Vue.prototype.$changeLanguage = (locale) => {
  i18n.locale = locale; // Dil değişikliği
  localStorage.setItem('language', locale); // Seçili dili kaydet
};

// Dil ayarlarını localStorage'dan yükle
const savedLanguage = localStorage.getItem('language');
if (savedLanguage) {
  i18n.locale = savedLanguage; // Kayıtlı dili kullan
}

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
